import React from "react";
import columbiaLogo from "../../assetFiles/columbiaLogo.png"
import bxsciLogo from "../../assetFiles/bxsciLogo.jpg"
import linkedinLogo from "../../assetFiles/LI-Logo.png"
import gmailLogo from "../../assetFiles/gmailLogo.png"
import githubLogo from "../../assetFiles/GitHub_Logo.png"
import "./Education.css"

function EducationPage () {
    return (
        <div style={{
        }}>
        <div className="education-page">
            <div style={{
                position: 'relative',
                top: '30px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '95%',   
                zIndex: 2,
                transition: 'opacity 1s ease-in'
            }}>
                <div style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    border: '2px solid #333',
                    borderRadius: '15px',
                    padding: '10px',
                    boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center'
                }}>
                    <a href="/Home" style={{ color: 'white', textDecoration: 'none' }}>Home</a>
                    <a href="/Education" style={{ color: 'white', textDecoration: 'none' }}>Education</a>
                    <a href="/Experience" style={{ color: 'white', textDecoration: 'none' }}>Experience</a>
                    <a href="/Leadership" style={{ color: 'white', textDecoration: 'none' }}>Leadership</a>
                    <a href="/Projects" style={{ color: 'white', textDecoration: 'none' }}>Projects</a>
                    <a href="/Skills" style={{ color: 'white', textDecoration: 'none' }}>Skills</a>
                </div>
            </div>
            <div>
                 <h1 style={{color: 'white', marginTop: '80px'}}>Education</h1>
            </div>
            <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            display: 'flex',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            zIndex: 2,
                            width: '43rem',
                            height: 'fit-content',
                            marginBottom: '2rem',
                            flexWrap: 'wrap',
                            justifyContent: 'center'
                        }}>
                            <div style={{
                                flexDirection: 'column'
                            }}>
                                <h2 style={{color: 'white'}}>Columbia University in the City of New York</h2>
                                <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                                    <span>Expected Degree: Bachelor's Degree</span>
                                    <span>Major: Computer Science</span>
                                </div>
                                <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                                    <span>May 2025</span>
                                    <span>GPA: 3.8</span>
                                </div>
                                <div style={{margin: '20px 0px'}}>
                                    <img style={{width: '300px', height: '300px', borderRadius: '15px'}}src={columbiaLogo} alt="Columbia Logo"></img>
                                </div>
                                <div style={{color: 'white', marginBottom: '20px'}}>
                                    <h3>Awards</h3>
                                    <span>Dean's List {'('}Fall 2021, Spring 2022, Fall 2022, Spring 2023, Fall 2023, Spring 2024{')'}</span>
                                </div>
                                <div style={{color: 'white', marginBottom: '20px', display: 'flex', flexDirection:'column'}}>
                                    <h3>Groups and Organizations</h3>
                                    <span style={{marginBottom: '5px'}}>Columbia University Residential Life</span>
                                    <span style={{marginBottom: '5px'}}>Columbia University Application Development Initiative</span>
                                    <span style={{marginBottom: '5px'}}>Columbia University Game Development Club</span>
                                    <span>Columbia University Undergraduate Law Review</span>
                                </div>
                                <div style={{color: 'white', display:'flex', alignItems: 'flex-start'}}>
                                    <h3>Relevant Coursework</h3>
                                </div>
                                <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px'}}></div>
                                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                    <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                        <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold'}}>Empirical Methods of Data Science</span>
                                        <span style={{paddingLeft: '20px'}}>Semester: Spring 2024</span>
                                        <span style={{paddingLeft: '20px'}}>Languages: Python, R, SQL</span>
                                        <span style={{paddingLeft: '20px'}}>Software: Tableau, Jupyter Notebook, DataGrip, PyCharm</span>
                                    </div>
                                </div>
                                <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px', marginTop: '10px'}}></div>
                                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                    <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                        <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold'}}>Digital Game Design</span>
                                        <span style={{paddingLeft: '20px'}}>Semester: Spring 2024</span>
                                        <span style={{paddingLeft: '20px'}}>Languages: C#, Python</span>
                                        <span style={{paddingLeft: '20px'}}>Software: Unity, Godot Engine, Figma</span>
                                    </div>
                                </div>
                                <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px', marginTop: '10px'}}></div>
                                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                    <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                        <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold'}}>Introduction to Databases</span>
                                        <span style={{paddingLeft: '20px'}}>Semester: Fall 2023</span>
                                        <span style={{paddingLeft: '20px'}}>Languages: Python, SQL, MySQL, Cypher</span>
                                        <span style={{paddingLeft: '20px'}}>Software: Jupyter Notebook, DataGrip, PyCharm, Neo4j</span>
                                    </div>
                                </div>
                                <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px', marginTop: '10px'}}></div>
                                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                    <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                        <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold'}}>Fundamentals of Computer Systems</span>
                                        <span style={{paddingLeft: '20px'}}>Semester: Fall 2023</span>
                                        <span style={{paddingLeft: '20px'}}>Language: MIPS {'('}Assembly{')'}</span>
                                        <span style={{paddingLeft: '20px'}}>Software: QTspim</span>
                                    </div>
                                </div>
                                <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px', marginTop: '10px'}}></div>
                                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                    <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                        <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold'}}>Computer Science Theory</span>
                                        <span style={{paddingLeft: '20px'}}>Semester: Fall 2023</span>
                                        <span style={{paddingLeft: '20px'}}>Core Topics: Automata, Context-Free Grammars, Turing Machines, Complexity Theory</span>
                                    </div>
                                </div>
                                <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px', marginTop: '10px'}}></div>
                                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                    <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                        <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold'}}>Linear Algebra and Probability</span>
                                        <span style={{paddingLeft: '20px'}}>Semester: Fall 2023</span>
                                        <span style={{paddingLeft: '20px'}}>Core Topics: Matrices, Determinants, Vector Spaces, Bases, Dimension, Eigenvalues </span>
                                        <span style={{paddingLeft:'115px'}}>and Eigenvectors, Spectral Theorem, Singular Value Decompositions, </span>
                                        <span style={{paddingLeft:'115px'}}>Applications to Probability, Statistics and Dynamical Systems</span>
                                    </div>
                                </div>
                                <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px', marginTop: '10px'}}></div>
                                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                    <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                        <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold'}}>Fundamentals of Computer Systems</span>
                                        <span style={{paddingLeft: '20px'}}>Semester: Spring 2023</span>
                                        <span style={{paddingLeft: '20px'}}>Language: C</span>
                                        <span style={{paddingLeft: '20px'}}>Software: Vim</span>
                                    </div>
                                </div>
                                <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px', marginTop: '10px'}}></div>
                                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                    <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                        <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold'}}>Calculus III</span>
                                        <span style={{paddingLeft: '20px'}}>Semester: Spring 2023</span>
                                        <span style={{paddingLeft: '20px'}}>Core Topics: Vectors and the Geometry of Space, Vector Functions,</span>
                                        <span style={{paddingLeft:'115px'}}>Functions of Several Variables and Partial Derivatives</span>
                                    </div>
                                </div>
                                <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px', marginTop: '10px'}}></div>
                                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                    <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                        <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold'}}>Data Structures in Java</span>
                                        <span style={{paddingLeft: '20px'}}>Semester: Fall 2022</span>
                                        <span style={{paddingLeft: '20px'}}>Language: Java</span>
                                        <span style={{paddingLeft: '20px'}}>Software: IntelliJ IDEA, Visual Studio Code</span>
                                    </div>
                                </div>
                                <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px', marginTop: '10px'}}></div>
                                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                    <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                        <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold'}}>Discrete Mathematics</span>
                                        <span style={{paddingLeft: '20px'}}>Semester: Fall 2022</span>
                                        <span style={{paddingLeft: '20px'}}>Core Topics: Theorems and Proofs, Relationships between Objects and Functions,</span>
                                        <span style={{paddingLeft:'115px'}}>Cryptography, Number Theory, Countability and Counting Sets and Operations</span>
                                        <span style={{paddingLeft:'115px'}}>on Objects, Discrete Probability Problems, Recurrence Relations, Graph Theory</span>
                                    </div>
                                </div>
                                <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px', marginTop: '10px'}}></div>
                                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                    <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                        <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold'}}>Introduction to Java</span>
                                        <span style={{paddingLeft: '20px'}}>Semester: Spring 2022</span>
                                        <span style={{paddingLeft: '20px'}}>Language: Java</span>
                                        <span style={{paddingLeft: '20px'}}>Software: Codio</span>
                                    </div>
                                </div>
                        </div>
                </div>
            </div>
            <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                <div style={{
                            display: 'flex',
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            zIndex: 2,
                            width: '43rem',
                            height: 'fit-content',
                            flexWrap: 'wrap',
                            justifyContent: 'center',
                            marginBottom: '2rem'
                        }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <h2 style={{color: 'white'}}>The Bronx High School of Science</h2>
                            <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                                <span>High School Diploma</span>
                                <span>Bronx, NY</span>
                            </div>
                            <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                                <span>June 2021</span>
                                <span>GPA: 96.52</span>
                            </div>
                            <div style={{margin: '20px 0px'}}>
                                <img style={{width: '325px', height: '300px', borderRadius: '15px'}}src={bxsciLogo} alt="Bronx Science Logo"></img>
                            </div>
                            <div style={{color: 'white', marginBottom: '20px', display: 'flex', flexDirection:'column'}}>
                                <h3>Awards</h3>
                                <span>Advanced Placement Scholar with Distinction {'('}June 2020, June 2021{')'}</span>
                                <span style={{marginBottom: '5px'}}>Excellence in Advanced Placement Calculus AB</span>
                            </div>
                            <div style={{color: 'white', marginBottom: '20px', display: 'flex', flexDirection:'column'}}>
                                <h3>Groups and Organizations</h3>
                                <span style={{marginBottom: '5px'}}>Moot Court</span>
                                <span style={{marginBottom: '5px'}}>Mock Trial</span>
                                <span style={{marginBottom: '5px'}}>Asian American Association</span>
                                <span style={{marginBottom: '5px'}}>Speech and Debate</span>
                                <span style={{marginBottom: '5px'}}>National Honors Society</span>
                            </div>
                        </div>
                </div>
            </div>
            <div style={{
                        position: 'relative',
                        bottom: '10px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '95%',
                        zIndex: 2
                    }}>
                    <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                        <span style={{ color: 'white' }}>© 2024 Steven Huang | Product Manager & Developer | v1.2 | stevenhuangtech@gmail.com</span>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center'  // This ensures vertical centering of the buttons
                            }}>
                            <span style={{ color: 'white'}}>Interested? Feel free to contact me! ---{'>'} </span>
                            <a 
                                href="mailto:stevenhuangtech@gmail.com" 
                                style={{
                                backgroundColor: 'white',
                                border: 'none',
                                padding: '5px',
                                margin: '0 5px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '20px',
                                height: '20px',
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = 0.7}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                                >
                                <img 
                                    src={gmailLogo}
                                    alt="Email"
                                    style={{
                                        width: '20px',
                                        height: '20px'
                                    }}
                                />
                            </a>
                            <a 
                                href="https://github.com/huangs-nyc" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                backgroundColor: 'white',
                                border: 'none',
                                padding: '5px',
                                margin: '0 5px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '70px',
                                height: '20px'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = 0.9}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                                >
                                <img 
                                    src={githubLogo} 
                                    alt="Github"
                                    style={{
                                    width: '50px',
                                    height: '20px'
                                    }}
                                />
                            </a>
                            <a 
                                href="https://www.linkedin.com/in/steven-huang-a60a8a22a/" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                backgroundColor: 'white',
                                border: 'none',
                                padding: '5px',
                                margin: '0 5px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100px',
                                height: '20px'
                            }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = 0.9}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                            >
                            <img 
                                src={linkedinLogo} 
                                alt="LinkedIn"
                                style={{
                                width: '80px',
                                height: '20px'
                                }}
                            />
                            </a>
                        </div>
                    </div>
            </div>
        </div>
        </div>
    );
}

export default EducationPage